import { Component, OnInit } from '@angular/core';
import { MatDialog } from "@angular/material";
import { MatDialogRef } from "@angular/material";

import { DevoteeDetail } from "./../../devotee/devotee-detail";
import { SharedService } from "./../../shared/shared.service";

@Component({
  selector: 'app-address-confirm-dialog',
  templateUrl: './address-confirm-dialog.component.html',
  styleUrls: ['./address-confirm-dialog.component.css']
})
export class AddressConfirmDialogComponent implements OnInit {

  constructor(private sharedService: SharedService
    , private dialogRef: MatDialogRef<AddressConfirmDialogComponent>) { }

  devoteeDetail: DevoteeDetail;

  ngOnInit() {
    this.devoteeDetail = this.sharedService.getDevoteeDataAtLocStorage();
  }

  closePopup(): void {
    this.dialogRef.close();
  }

  confirmAndClosePopUp():void{
    this.dialogRef.close("Confirm"); 
  }


}



// WEBPACK FOOTER //
// ./src/app/prasad-order/address-confirm-dialog/address-confirm-dialog.component.ts